/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

// import * as Msdyn365 from '@msdyn365-commerce/core';
import {
    CacheType,
    createObservableDataAction,
    IAction,
    IActionContext,
    IActionInput,
    ICreateActionContext
} from '@msdyn365-commerce/core';

import { getOrderPoNumberAsync } from './DataService/DataActionExtension.g';
import { IGetOrderPoNumberResponse } from './DataService/DataServiceEntities.g';

/**
 * GetorderponumberInput Input Action
 */
export class GetorderponumberInput implements IActionInput {
    // Input properties
    public orderId: string;

    // TODO: Construct the input needed to run the action
    constructor(orderId: string) {
        this.orderId = orderId;
    }

    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `GetorderponumberInput`;
    public getCacheObjectType = () => 'GetorderponumberInput';
    public dataCacheType = (): CacheType => 'none';
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
const createInput = (args: ICreateActionContext, orderId: string): IActionInput => {
    return new GetorderponumberInput(orderId);
};

export async function GetOrderPoNumber(input: GetorderponumberInput, ctx: IActionContext): Promise<IGetOrderPoNumberResponse> {
    return getOrderPoNumberAsync({ callerContext: ctx }, input.orderId)
        .then(data => {
            return data;
        })
        .catch(error => {
            ctx.telemetry.exception(error);
            ctx.trace('[get-po-number] Unable to load order po number');
            throw new Error('[get-po-number] Unable to load order po number');
        });
}

export default createObservableDataAction({
    action: <IAction<IGetOrderPoNumberResponse>>GetOrderPoNumber,
    id: 'GetOrderPoNumber',
    input: createInput
});
